module.exports = __webpack_public_path__ + "media/packs/images/flags/TR-57dfdfa14067529ebe6f0a2d8f703009.svg";